<template>
  <div
    class="lg:mx-5 flex flex-col mx-11 justify-center items-center lg:grid lg:grid-cols-6 lg:gap-4"
  >
    <div class="lg:col-start-1 lg:col-end-4">
      <profilecard />
    </div>
    <div class="lg:col-span-3">
      <change-password />
    </div>
    <div class="lg:col-start-1 lg:col-end-7 lg:mr-2 flex-shrink">
      <notification-table />
    </div>
  </div>
</template>

<script>
import ChangePassword from "../../components/Candidate/overview/ChangePassword.vue";
import Profilecard from "../../components/Candidate/overview/profilecard.vue";
import NotificationTable from "../../components/Candidate/overview/table.vue";

export default {
  name: "Overview",
  components: { Profilecard, NotificationTable, ChangePassword },
  data() {
    return {
      newUser: false,
    };
  },
};
</script>
